<template>
    <entity-editor
        entity="lammie"
        :id="id"
        api-name="lammieRequests"
        :new-entity="newLammieRequest"
        @isDirtyChange="handleIsDirtyChange"
    >
        <template v-slot:[`editor`]="{ doc }">
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.name" :rules="[requiredRule]">
                        <template v-slot:[`label`]>
                            <label-required name="Name" />
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-select
                        v-model="doc.plotKeyId"
                        :rules="[requiredRule]"
                        :items="plots"
                        :disabled="isLoading"
                        label="Event"
                        outlined
                        dense
                    >
                        <template v-slot:[`label`]>
                            <label-required name="Plot" />
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-select
                        v-model="doc.eventId"
                        :rules="[requiredRule]"
                        :items="events"
                        item-text="name"
                        item-value="id"
                        :disabled="isLoading"
                        label="Event"
                        outlined
                        dense
                    >
                        <template v-slot:[`label`]>
                            <label-required name="Active From" />
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" md="4">
                    <v-select
                        v-model="doc.requiredDuration"
                        :rules="[requiredRule]"
                        :items="duration"
                        :disabled="isLoading"
                        label="Duration"
                        outlined
                        dense
                    >
                        <template v-slot:[`label`]>
                            <label-required name="Duration" />
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" md="4">
                    <v-checkbox v-model="doc.isReprint" label="Is Reprint?" dense class="mt-1"></v-checkbox>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.physRep" label="Phys Rep" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.intendedPurpose" label="Intended Purpose" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.powers" label="Powers" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.notes" label="Notes" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.loreCodes" label="Lore Codes" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
        </template>
    </entity-editor>
</template>
<script>
import api from '@/api'
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
import editorMixin from '../../mixins/editorMixin'
import RequiresLabel from '../../components/RequiredLabel'
import orderByTeam from '../../components/orderByTeam'
export default {
    name: 'LammieRequestEditor',
    mixins: [navGuardConfirmMixin, editorMixin],
    components: {
        'label-required': RequiresLabel,
    },
    props: {
        id: {
            type: [Number, String],
            required: false,
            validator: value => {
                return !!value
            },
        },
    },
    data() {
        return {
            plots: [],
            duration: [{ text: 'Event' }, { text: '6 Months' }, { text: 'Year' }],
        }
    },
    mounted() {
        this.getPlots()
    },
    methods: {
        newLammieRequest() {
            return {
                name: '',
                eventId: this.nextEventId,
                teamId: null,
                plotKeyId: 0,
                requiredDuration: '',
                isReprint: false,
                physRep: '',
                intendedPurpose: '',
                powers: '',
                notes: '',
                loreCodes: '',
            }
        },
        getPlots() {
            this.isLoading = true
            let apiUrl = `/plots`
            api.get(apiUrl)
                .then(res => {
                    let plots = res.map(x => {
                        let team = this.teamCount > 1 || this.user.lammie.all ? `(${x.teamName}) ` : ''
                        x.text = `${team}${x.name}`
                        x.value = x.keyId
                        return x
                    })
                    this.plots = orderByTeam(plots, this.userDefaultTeamId)
                })
                .finally(() => (this.isLoading = false))
        },
    },
}
</script>
